import { fromJS } from 'immutable';

import { logoutType } from '@Constants/User';
import { updateUserDetailsType } from './UserDetailsConstants';

export const initialState = fromJS({});

// eslint-disable-next-line default-param-last
export default function userDatabasesReducer(state = initialState, action) {
  switch (action.type) {
    case updateUserDetailsType: {
      const { details } = action.payload;

      if (!details) {
        return initialState;
      }

      return fromJS(details);
    }

    case logoutType: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
